module.exports = __webpack_public_path__ + "static/sui-button-animated-448adcf4101dcf8749fbb12b275089e2.gif";